@if (isLoading()) {
  <p>Loading API keys...</p>
} @else {
  <div class="app-column gapped">
    <p>
      API keys allow you to authenticate with the SysPromptHub API.
      You can have up to {{ MAX_KEYS }} active keys at a time.
    </p>

    @if (canCreateKey) {
      <div class="app-row">
        <app-button type="new" label="Create API Key" (clicked)="openCreateDialog()"/>
      </div>
    } @else {
      <div class="rounded padded text-bg-warning app-row gapped">
        <icon type="warning"/>
        <div>
          You have reached the maximum number of API keys ({{ MAX_KEYS }}).
          Delete an existing key to create a new one.
        </div>
      </div>
    }

    @if (apiKeys().length === 0) {
      <p>No API keys found. Create one to get started.</p>
    } @else {
      <table>
        <thead>
        <th>Name</th>
        <th>Key</th>
        <th>Expiration</th>
        <th>Actions</th>
        </thead>
        <tbody>
          @for (key of apiKeys(); track key.id) {
            <tr>
              <td class="fill-33">
                <app-editable-text
                  [control]="getNameControl(key.id)"
                  placeholder="Unnamed key"
                  (saving)="updateKeyName(key)"/>
              </td>

              <td class="fill-33">{{ key.key }}</td>
              <td [class.text-danger]="key.expired" [class.text-warning]="key.expiringSoon && !key.expired">
                {{ formatExpiration(key) }}
              </td>

              <td>
                <div class="app-row-auto">
                  <app-button
                    type="copy"
                    transparent
                    (clicked)="copyToClipboard(key.key)"/>
                  @if (!key.expired) {
                    <app-button
                      type="cancel"
                      transparent
                      description="Expire key"
                      (clicked)="expireKey(key)"/>
                  }
                  <app-button
                    type="delete"
                    transparent
                    description="Delete key"
                    (clicked)="deleteKey(key)"/>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
}

<app-dialog [open]="showCreateDialog()" [title]="'Create API Key'" (closed)="closeCreateDialog()">
  <div dialog-body>
    <div class="field-grid">
      <label for="key-name">Name (Optional)</label>
      <input
        id="key-name"
        type="text"
        [value]="newKeyName()"
        (input)="newKeyName.set($any($event.target).value)"
        placeholder="Production API Key"
        [disabled]="isCreating()"
        maxlength="100"/>

      <label for="key-expiration">Expiration</label>
      <select
        id="key-expiration"
        [value]="newKeyExpiration()"
        (change)="newKeyExpiration.set($any($event.target).value ? +$any($event.target).value : null)"
        [disabled]="isCreating()">
        <option [value]="30">30 days</option>
        <option [value]="60">60 days</option>
        <option [value]="90">90 days</option>
        <option [value]="180">180 days</option>
        <option [value]="null">Never</option>
      </select>
    </div>

    <p class="text-secondary">
      The API key will be generated automatically and can only be viewed once.
      Make sure to copy it after creation.
    </p>
  </div>

  <div dialog-footer>
    <app-button type="cancel" (clicked)="closeCreateDialog()" [disabled]="isCreating()"/>
    <app-button type="save" label="Create" (clicked)="createKey()" [disabled]="isCreating()"/>
  </div>
</app-dialog>

